import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
} from "../components-shadcn/dialog"
import { ReactComponent as ErrorIcon } from '../assets/error.svg'
import { ReactComponent as Success } from '../assets/success.svg'
import { ReactComponent as Processing } from '../assets/processing.svg'
import { AmplitudeLog } from '../lib/amplitude';
import { useStore } from '../lib/store';

type IconKey = 'error' | 'success' | 'processing'
type IconComponent = React.FC<React.SVGProps<SVGSVGElement>>
interface Props {
  open: boolean
  close?: React.Dispatch<React.SetStateAction<boolean>>
  icon: IconKey
  title: string
  legend: string
}
const PaymentStatus: React.FC<Props> = ({ open, close, icon, title, legend }) => {

  const icon_model: Record<IconKey, IconComponent> = {
    'error': ErrorIcon,
    'success': Success,
    'processing': Processing,
  }
  const IconComponent = icon_model[icon]

  const [isOpen, setIsOpen] = useState(open);
  const { user } = useStore();

  useEffect(() => {
    if (open) {
      setIsOpen(true);
      setTimeout(() => {
        setIsOpen(false);
        close && close(true);
      }, 5000);
    }
  }, [open])

  return (
    <Dialog open={isOpen}>
      <DialogContent showCloseButton={false} className="bg-white-primary flex justify-center items-center flex-col">
        <IconComponent className='w-[3.83rem] h-[3.83rem]' />
        <p className='text-blue-primary text-[1.2rem] font-[700]'>{title}</p>
        <p className='text-center'>{legend}</p>
      </DialogContent>

    </Dialog>
  )
}

export default PaymentStatus;
